// Change website animations
const animation = {
  // make it false to switch off fade-up animation
  animate: true,
  // animation playing duration
  duration: 750,
  // if true, animation plays only once when element comes on screen
  once: false,
};
// Change your display name on tha landing display
const header = {
  name: "Hassen GHNIMI",
};
const background = {
  // Options: Snow or Particle
  type: "Particle",
};
// Write a para about yourself here
// To update your image, go to './styles/images.css'
const section2title = "About Me";
const about = {
  paragraph:
    "I am a 31 year old Software Developer, living in Tunisia. I have a passion for software development and love producing results. I am currently interested in Web Development (MERN stack developer).",
};

// Edit your projects, its name, your skills used to make it, and the url.
// You can omit freely anything if you dont have it
// To Add a Project, copy any one below and paste it after the last comma and increment the id's project number
const section3Title = "Past Projects";
const projects = [];
// Edit your Miscellaneous Activities, its name and the url.
// You can omit freely anything if you dont have it
// To Add a Activity, copy any one below and paste it after the last comma and increment the id's Miscellaneous number
const section4Title = "Education";

// Contact form text, and Jotforms link
// To get your own jotform link, go to https://www.jotform.com/
// If you hacve the link already, paste it in the contactUrl below
const section5Title = "Get in Touch";
const contact = {
  pitch: "I am always looking for new opportunities and endeavours to take on.",
  contactUrl: "",
};
//List Experiences
const experiences = [
  {
    _id: "60d09d9b6c85e00ddcb92b2fb",
    employer: "ITM-BC",
    position: "intership",
    description: `Create the advertising section in a web application "My Craft Solutions".`,
    skills: "Reactjs SpringBoot",
    date: "mai 2023",
  },
  {
    _id: "60d09d9b6c85e00ddcb92b2f",
    employer: "Best Web Mobile",
    position: "intership",
    description: "creation of a movies application with react js",
    skills: "HTML5 CSS3 JS Reactjs hooks",
    date: "oct 2020 - nov 2020",
  },
  {
    _id: "60d085326c85e00ddcb92b2e",
    employer: "Master Class",
    position: "Reactjs training",
    description: "creation of a coronavirus tracking application",
    skills: "HTML5 CSS3 JS Reactstrap Reactjs hooks",
    date: "fev 2020 - juin 2020",
  },
  {
    _id: "60d0846d6c85e00ddcb92b2d",
    employer: "AMBRA",
    position: "IT Manager",
    description:
      "Installation, maintenance and security of the operating system and of information",
    skills: "",
    date: "oct 2018 - sep 2019",
  },
  {
    _id: "60d083366c85e00ddcb92b2c",
    employer: "L’univers Informatique ",
    position: "PFE internship",
    description: "Supervision of a smart home through a ANDROID smartphone",
    skills: "JAVA C",
    date: "fev 2018 - Mai 2018",
  },
  {
    _id: "60d0822f6c85e00ddcb92b2b",
    employer: "Tunisia Telecom",
    position: "Summer intership",
    description: "",
    skills: "",
    date: "juil 2017 - Aout 2017",
  },
];
//List Skills
const skillsList = [
  {
    _id: "60d07e5a6c85e00ddcb92b21",
    content: "HTML5",
    iconClass: "fab fa-html5",
  },
  {
    _id: "60d07e696c85e00ddcb92b22",
    content: "CSS3",
    iconClass: "fab fa-css3",
  },
  {
    _id: "60d07e856c85e00ddcb92b23",
    content: "Javascript",
    iconClass: "fab fa-js",
  },
  {
    _id: "60d07e946c85e00ddcb92b24",
    content: "Bootstrap",
    iconClass: "fab fa-bootstrap",
  },
  {
    _id: "60d07ea96c85e00ddcb92b25",
    content: "React",
    iconClass: "fab fa-react",
  },
  {
    _id: "60d07ec16c85e00ddcb92b26",
    content: "Node",
    iconClass: "fab fa-node",
  },
  {
    _id: "62738a07c2b9f900043f5f34",
    content: "Express",
    iconClass: "",
  },
  {
    _id: "62738a13c2b9f900043f5f35",
    content: "MongoDB",
    iconClass: "",
  },
  {
    _id: "60d07edc6c85e00ddcb92b28",
    content: "Angular",
    iconClass: "fab fa-angular",
  },
  {
    _id: "60d34fdc6dafb300046cb916",
    content: "NestJS",
    iconClass: "fab fa-nest",
  },
  {
    _id: "60d34fdc6dafb300046cb916",
    content: "SpringBoot",
    iconClass: "",
  },
  {
    _id: "621f16d9ef2f240004b8ab71",
    content: "NextJS",
    iconClass: "fab fa-next",
  },
  {
    _id: "62738a32c2b9f900043f5f36",
    content: "MaterialUI",
    iconClass: "",
  },
  {
    _id: "60d07eec6c85e00ddcb92b29",
    content: "Firebase",
    iconClass: "fas fa-fire",
  },

  {
    _id: "60d07ece6c85e00ddcb92b27",
    content: "Github",
    iconClass: "fab fa-git-alt",
  },
];
//List Projects
const projectsList = [
  {
    _id: "6273f07c784ac300048f3027",
    name: "E-commerceNestJs&ReactJs",
    skills: "NestJs ReactJS",
    url: "",
    photo:
      "https://res.cloudinary.com/dnw7or6mq/image/upload/v1677195369/screencapture-localhost-3000-2023-02-22-12_40_56_ekazi9.png",
  },
  {
    _id: "6273f107784ac300048f3048",
    name: "BookingApp",
    skills: "NodeJs ReactJS ExpressJs MongoDB",
    url: "https://bookingmern.netlify.app/",
    photo:
      "https://res.cloudinary.com/dnw7or6mq/image/upload/v1669317633/portfolio/screencapture-bookingmern-netlify-app-2022-11-14-12_13_15_yyzzjw.png",
  },
  {
    _id: "6273f020784ac300048f3451",
    name: "PortalJob",
    skills: "NodeJs ReactJS ExpressJs MongoDB",
    url: "https://portal-job-mern.netlify.app/",
    photo:
      "https://res.cloudinary.com/dnw7or6mq/image/upload/v1669317844/portfolio/screencapture-portal-job-mern-netlify-app-2022-11-14-12_14_03_t0v1m2.png",
  },
  {
    _id: "6273f107784ac300048f3028",
    name: "ChatApp",
    skills: "NodeJs ReactJS ExpressJs MongoDB Socket.io",
    url: "https://mernchatrealtime.netlify.app/",
    photo:
      "https://res.cloudinary.com/dnw7or6mq/image/upload/v1652012286/avatar/lrwmlgbmqtvnr9mfuxrq.png",
  },
  {
    _id: "6273f020784ac300048f3026",
    name: "Nextjs-Ecommerce",
    skills: "Nextjs NodeJs ExpressJs MongoDB material-UI",
    url: "https://nextjsecommerce.netlify.app/",
    photo:
      "https://res.cloudinary.com/dnw7or6mq/image/upload/v1652012556/avatar/diajvtotrxoilcgnewfy.png",
  },
];
// Paste your respective social media links. You can omit any if you dont have it
// Upload your resume in your drive, get the shaareable link and paste it in the resume section
const social = {
  github: "https://github.com/ghnimi1",
  facebook: "https://www.facebook.com/ghnimi.hassen2",
  linkedin: "https://www.linkedin.com/in/ghnimi-hassen-43882086/",
  instagram: "https://instagram.com",
  resume: "cvhassen.pdf",
};
// Dont change anything here
export {
  animation,
  header,
  background,
  about,
  projects,
  contact,
  social,
  skillsList,
  experiences,
  projectsList,
  section2title,
  section3Title,
  section4Title,
  section5Title,
};
